import React from "react";

import { Row, Col, Statistic, Icon } from "antd";

import { secons2Dhm } from "../../services/timeFunctions";

import { marksAgitation } from "../../constants";

//import multilanguage library
import { useTranslation } from "react-i18next";

// Styles
import { FigureInfomationWrapper } from "./styles";

import colors from "../../theme/colors";

const RenderDesingProcessData = ({ selectedProcessDesing }) => {
  //To translate text
  const { t } = useTranslation();

  if (!selectedProcessDesing) return null;
  return (
    <FigureInfomationWrapper>
      <Row style={{ margin: 0 }} gutter={[16, 16]}>
        <Col span={8}>
          <h3>{t("phase.furnace")}</h3>
          <Col span={24}>
            <Statistic
              title={t("labels.temperature")}
              value={selectedProcessDesing && selectedProcessDesing.furnace && selectedProcessDesing.furnace.temperature}
              suffix="ºC"
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.ramp")}
              value={
                selectedProcessDesing && selectedProcessDesing.furnace && selectedProcessDesing.furnace.heating_ramp === 5000
                  ? t("labels.no_ramp")
                  : selectedProcessDesing.furnace.heating_ramp
              }
              suffix={
                selectedProcessDesing && selectedProcessDesing.furnace && selectedProcessDesing.furnace.heating_ramp === 5000 ? "" : "ºC/h"
              }
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.temperature_piece")}
              value={selectedProcessDesing && selectedProcessDesing.furnace && selectedProcessDesing.furnace.piece_temperrature}
              suffix="ºC"
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.time_d_hh_mm")}
              value={
                selectedProcessDesing &&
                selectedProcessDesing.recommendation &&
                selectedProcessDesing.recommendation.furnace_time &&
                secons2Dhm(selectedProcessDesing.recommendation.furnace_time)
              }
            />
          </Col>
        </Col>

        <Col span={8}>
          <h3>{t("phase.quenching")}</h3>
          <Col span={24}>
            <Statistic
              title={t("labels.temperature")}
              value={selectedProcessDesing && selectedProcessDesing.quenching && selectedProcessDesing.quenching.bath_temperature}
              suffix="ºC"
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.agitation")}
              value={
                selectedProcessDesing && selectedProcessDesing.quenching && marksAgitation[selectedProcessDesing.quenching.agitation_level]
              }
              suffix={selectedProcessDesing.quenching.agitation_level === 0 ? "" : "m/s"}
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.hard_coat")}
              value={selectedProcessDesing && selectedProcessDesing.quenching && selectedProcessDesing.quenching.hard_coat}
              suffix="mm"
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.tempered_coat")}
              value={selectedProcessDesing && selectedProcessDesing.recommendation && selectedProcessDesing.recommendation.quenching}
              suffix="mm"
              prefix={
                selectedProcessDesing &&
                selectedProcessDesing.recommendation &&
                selectedProcessDesing.recommendation.quenching &&
                selectedProcessDesing.quenching &&
                selectedProcessDesing.quenching.hard_coat &&
                selectedProcessDesing.recommendation.quenching < selectedProcessDesing.quenching.hard_coat ? (
                  <Icon style={{ color: colors.danger }} type="warning" />
                ) : (
                  <Icon style={{ color: colors.success }} type="check" />
                )
              }
            />
          </Col>
        </Col>

        <Col span={8}>
          <h3>{t("phase.tempered")}</h3>
          <Col span={24}>
            <Statistic
              title={t("labels.temperature")}
              value={selectedProcessDesing && selectedProcessDesing.tempered && selectedProcessDesing.tempered.temperature}
              suffix="ºC"
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.ramp")}
              value={
                selectedProcessDesing && selectedProcessDesing.tempered && selectedProcessDesing.tempered.heating_ramp === 5000
                  ? t("labels.no_ramp")
                  : selectedProcessDesing.furnace.heating_ramp
              }
              suffix={
                selectedProcessDesing && selectedProcessDesing.tempered && selectedProcessDesing.tempered.heating_ramp === 5000
                  ? ""
                  : "ºC/h"
              }
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.hardness")}
              value={selectedProcessDesing && selectedProcessDesing.tempered && selectedProcessDesing.tempered.hardness_required}
              suffix="HV1"
            />
          </Col>
          <Col span={24}>
            <Statistic
              title={t("labels.time_d_hh_mm")}
              value={
                selectedProcessDesing &&
                selectedProcessDesing.recommendation &&
                selectedProcessDesing.recommendation.tempered_time &&
                secons2Dhm(selectedProcessDesing.recommendation.tempered_time)
              }
            />
          </Col>
        </Col>
      </Row>
    </FigureInfomationWrapper>
  );
};

export default RenderDesingProcessData;
